module.exports = function(service) {
	'use strict'
	service.factory('removeFromOther',removeFromOther);
	removeFromOther.$inject=['deleteDataService','refreshtokenService','serverError','alertService','offlineError'];
	function removeFromOther(deleteDataService,refreshtokenService,serverError, alertService, offlineError) {
        return function(url) {
            var deleteFunction = function() {
                deleteDataService.remove(url).$promise.then(function(data){ 
                alertService('success','Success ', data.message, 2000);
                }, function(error){
                if(!window.navigator.onLine) {
                    offlineError()
                    $rootScope.hasLoaded = true;
                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                    return
                }
                if(error.status ==401) {
                    var promise = refreshtokenService.getAccessToken();
                    promise.then(
                    function(answer) {
                        if(answer==200) {   
                        deleteFunction();
                        }
                    },
                    function(error) {
                        // report something
                    },
                    function(progress) {
                        // report progress
                    });
                }else if(error.status ==502) {
                    serverError()
                } else {
                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                }  
                });
            }
            deleteFunction();
        
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/removeFromOtherService.js
// module id = 623
// module chunks = 0